import { render, staticRenderFns } from "./ClientsOverview.vue?vue&type=template&id=68c0c5d5&scoped=true"
import script from "./ClientsOverview.vue?vue&type=script&lang=js"
export * from "./ClientsOverview.vue?vue&type=script&lang=js"
import style0 from "./ClientsOverview.vue?vue&type=style&index=0&id=68c0c5d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c0c5d5",
  null
  
)

export default component.exports